import React from 'react';
import {
    View,
    Text,
    Pressable
  } from 'react-native';
const Logout=()=>{
    const handleLogout=()=>{
        Object.keys(localStorage).forEach(function(key){
            if(key.indexOf("workflow")>-1){
              localStorage.removeItem(key);
            }
          });

          Object.keys(localStorage).forEach(function(key){
            if(key.indexOf("codeblue")>-1){
              localStorage.removeItem(key);
            }
          });
        localStorage.removeItem('token');
        window.location.reload();
    };
    return(
        <View style={{alignSelf:'center', marginLeft:'70%'}}>
            <Pressable style={{backgroundColor:'red', width:70, height:35, justifyContent:'center', borderRadius:5}} onPress={handleLogout}><Text style={{textAlign:'center', color:"#fff", fontWeight:'bold'}}>Logout</Text></Pressable>
        </View>
    );
};

export default Logout;
